export default __webpack_public_path__ + "static/media/Yes.746073c0.mp3";